// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"368d4068","703":"c85b904f"}[chunkId] + ".chunk.js";
};